var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.678,
    height: 18.168,
    viewBox: "0 0 14.678 18.168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-delete-4175927",
    transform: "translate(-75.962 -21.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3713",
    "data-name": "Path 3713",
    d: "M142.641,38.634a2.47,2.47,0,0,0,1.755.726h.008l7.721-.025h0a2.491,2.491,0,0,0,2.479-2.487v-10.7h.555a.437.437,0,0,0,.437-.437V23.635a.437.437,0,0,0-.437-.437h-3.933v-1.57a.437.437,0,0,0-.437-.437h-5.064a.437.437,0,0,0-.437.437V23.2h-3.934a.437.437,0,0,0-.437.437v2.078a.437.437,0,0,0,.437.437h.555V36.873a2.469,2.469,0,0,0,.731,1.761Zm11.09-1.787a1.616,1.616,0,0,1-1.608,1.613l-7.721.025H144.4a1.613,1.613,0,0,1-1.613-1.613V26.149H153.73Zm-7.569-14.783h4.19V23.2h-4.19Zm-4.371,2.007h12.931v1.2H141.791Z",
    transform: "translate(-64.956 0)",
    fill: "#f37321"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3714",
    "data-name": "Path 3714",
    d: "M337.992,225.708a.437.437,0,0,0,.437-.437v-6.617a.437.437,0,0,0-.874,0v6.617a.437.437,0,0,0,.437.437Z",
    transform: "translate(-254.691 -190.111)",
    fill: "#f37321"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3715",
    "data-name": "Path 3715",
    d: "M262.782,225.708a.437.437,0,0,0,.437-.437v-6.617a.437.437,0,0,0-.874,0v6.617a.437.437,0,0,0,.437.437Z",
    transform: "translate(-182.121 -190.111)",
    fill: "#f37321"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3716",
    "data-name": "Path 3716",
    d: "M413.2,225.708a.437.437,0,0,0,.437-.437v-6.617a.437.437,0,0,0-.874,0v6.617a.437.437,0,0,0,.437.437Z",
    transform: "translate(-327.261 -190.111)",
    fill: "#f37321"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.b7a4c29df7ac9c51f21fd536c62a17c1.svg";
export { ForwardRef as ReactComponent };